const steps = [
    {
        key: 'details',
        name: 'program_details',
        componentName: 'EditProgramDetailsForm',
    },
    {
        key: 'enrollment',
        name: 'enrollment_details',
        componentName: 'Enrollment',
    },
    {
        key: 'tracked_attributes',
        name: 'attributes',
        componentName: 'AssignAttributes',
    },
    {
        key: 'stages',
        name: 'program_stages',
        componentName: 'ProgramStage',
    },
    {
        key: 'assign_organisation_units',
        name: 'organisation_units',
        componentName: 'AssignOrganisationUnits',
    },
    {
        key: 'notifications',
        name: 'notifications',
        componentName: 'TrackerProgramNotifications',
    },
];

export default steps;



// WEBPACK FOOTER //
// ./src/EditModel/event-program/tracker-program/tracker-program-steps.js